import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import templateAction from 'modules/template/template.action';
import { AppState } from 'store';
import AdmAddCalculationSettingsGrade from './AdmAddCalculationSettingsGrade';
import { TStep5 } from './AdmAddCalculationSettingsGrade.state';

const AdmAddCalculationSettingsGradeContainer = () => {
  const dispatch = useDispatch();
  const template = useSelector((state: AppState) => state.pages.template);
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupClass);
  const baseLibState = useSelector((state: AppState) => state.pages.baseLibrary);

  const updateTemplate = (data: TStep5, id: string, buttonFooter: boolean, link?: string) => {
    if (currentGroup.id) {
      dispatch(templateAction.updateTemplateStep5({ groupId: currentGroup.id, data, id, buttonFooter, link }));
    }
  };

  return (
    <AdmAddCalculationSettingsGrade updateTemplate={updateTemplate} baseLibState={baseLibState} template={template} />
  );
};

export default AdmAddCalculationSettingsGradeContainer;
